import React, { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";
import "../styles/Team.css";

function Team() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const fetchTeam = async () => {
      let { data, error } = await supabase.from("team").select("*");
      if (!error && data) setTeam(data);
    };
    fetchTeam();
  }, []);

  return (
    <section className="team-section">
      <h2 className="team-heading">Meet Our Team</h2>
      <div className="team-carousel">
        <div className="team-track">
          {team.concat(team).map((member, index) => (
            <div className="team-card" key={index}>
              <img src={member.image_url} alt={member.name} />
              <h3>{member.name}</h3>
              <h4>{member.title}</h4>
              <p>{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
